var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trtc-container"},[_c('div',{attrs:{"id":"localVideo"}}),_c('div',{staticClass:"controls"},[_c('button',{on:{"click":_vm.startCall}},[_vm._v("开始通话")])])])}
var staticRenderFns = []

export { render, staticRenderFns }